













































































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";
import { mapState } from "vuex";

// Mixins
import BillableEntitiesInjectorMixin from "@/mixins/billableEntitiesInjectorMixin";

// Types
import { IAddress } from "@/models/addresses";
import { ICompany } from "@/models/companies";
import { IState } from "@/store";
import { ICountry } from "@/models/constants";

@Component({
  computed: {
    ...mapState({
      countries: (state: IState) => state.constants.countries
    })
  },
  components: {
    "billable-address-entity": () =>
      import("@/components/app/global/client/billableAddressEntity.vue"),
    "billable-company-entity": () =>
      import("@/components/app/global/client/billableCompanyEntity.vue"),
    "billable-entities-control": () =>
      import("@/components/app/global/client/billableEntitiesControl.vue")
  }
})
export default class BillableEntities extends Mixins(
  BillableEntitiesInjectorMixin
) {
  // Map State
  public countries!: ICountry[];

  // Props

  @Prop({ default: null })
  public addressId!: IAddress["id"];

  @Prop({ default: null })
  public companyId!: ICompany["id"];

  @Prop({ default: false })
  public isProcessing!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: true })
  public isSelectable!: boolean;

  @Prop({ default: 0 })
  public skeletonSize!: number;

  @Prop({ default: false })
  public selectInitialDefault!: boolean;

  // Data

  public selectedEntityId = this.companyId
    ? `company_${this.companyId}`
    : this.addressId
    ? `address_${this.addressId}`
    : "";

  // Life-cycle methods

  public created() {
    this.$bus.$on("selectBillableEntity", this.selectEntity);
  }

  public beforeDestroy() {
    this.$bus.$off("selectBillableEntity");
  }

  // Methods

  public isCompany(entity) {
    return _.has(entity, "address_id");
  }

  public selectEntity(entity) {
    if (this.isDisabled) return;
    if (!this.isCompany(entity)) {
      if (this.selectedEntityId === `address_${entity.id}`) return;
      this.selectedEntityId = `address_${entity.id}`;
      this.$emit("selectAddress", entity);
      return;
    }
    if (this.selectedEntityId === `company_${entity.id}`) return;
    this.selectedEntityId = `company_${entity.id}`;
    this.$emit("selectCompany", entity);
  }

  // Computed

  public get skeletonGridSize() {
    if (this.skeletonSize) return this.skeletonSize;
    return (
      this.billableEntitiesData.entities.length ||
      (this.$store.getters["ui/isMobile"] ? 3 : 6)
    );
  }

  public get defaultEntity() {
    const defaultAddress = _.find(this.billableEntitiesData.addresses, [
      "default",
      true
    ]);
    const defaultCompany = _.find(this.billableEntitiesData.companies, [
      "default",
      true
    ]);

    return defaultAddress || defaultCompany;
  }

  // Watchers

  @Watch("addressId")
  public onAddressChanged() {
    this.selectedEntityId = this.companyId
      ? `company_${this.companyId}`
      : this.addressId
      ? `address_${this.addressId}`
      : "";
  }

  @Watch("companyId")
  public onCompanyChanged() {
    this.selectedEntityId = this.companyId
      ? `company_${this.companyId}`
      : this.addressId
      ? `address_${this.addressId}`
      : "";
  }

  @Watch("billableEntitiesData.isLoading")
  public onBillableEntitiesLoad() {
    if (
      this.selectInitialDefault &&
      this.selectedEntityId === "" &&
      !!this.defaultEntity
    ) {
      this.selectEntity(this.defaultEntity);
    }
  }
}
